<template>

  <div class="p-fluid report-field">
    <div v-if="guide.label" class="p-grid report-field-header">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label>{{$t('report.'+section+'.'+guide.label)}}</label>
      </div>
    </div>
    <div v-for="(children) in guide.childrens" :key="children.c_key" style="padding-right: .5rem;" class="p-grid p-ai-center" >

      <div class="p-col" style="padding-right: 0; line-height: 1rem;">
        {{$t('report.'+section+'.'+children.c_key)}}
      </div>

      <div class="p-col-fixed" :class="['timeslot',{'timeslot-overview':overview}]">
        <span v-if="!overview" class="p-input-icon-right">
          <i class="pi pi-clock" />
          <InputMask v-model="values[children.c_key].start" mask="99:99" placeholder="--:--" @blur="dataChanged(children)" :class="{'p-invalid':children.invalid}" 
              :disabled="guide.disabled" :aria-label="$t('report.'+section+'.'+children.c_key)"/>
        </span>
        <span v-else>{{ values[children.c_key].start }}</span>
      </div>

      <div class="p-col-fixed p-text-center" style="width: 10px; padding: 0">-</div>

      <div class="p-col-fixed" :class="['timeslot',{'timeslot-overview':overview}]" >
        <span v-if="!overview" class="p-input-icon-right">
          <i class="pi pi-clock" />
          <InputMask v-model="values[children.c_key].end" mask="99:99" placeholder="--:--" @blur="dataChanged(children)" :class="{'p-invalid':children.invalid}" 
              :disabled="guide.disabled" :aria-label="$t('report.'+section+'.'+children.c_key)"/>
        </span>
        <span v-else>{{ values[children.c_key].end }}</span>
      </div>
      
    </div>
  </div>

</template>

<script>
export default {
  emits: ['update:data'],
  components: {
  },
  props: {
      section: String,
      guide: Object,
      data: Object,
      domains: Object,
      overview: Boolean
    },
  data() {
    return {
      values: {}
    }
  },
  computed: {
  },
  created() {
    for(let children of this.guide.childrens) {
      if(children.c_type === 'timeslot' && this.data[children.c_key]) {
        let timeslot = this.data[children.c_key].split("|||");
        this.values[children.c_key] = {
          start: timeslot[0],
          end: timeslot[1]
        };
      } else {
        this.values[children.c_key] = {
          start: null,
          end: null
        };
      }
    }
  },
  mounted() {
  },
  watch: {
    'guide.disabled': 'resetField',
    'guide.hidden': 'resetField',
  },
  methods: {
    dataChanged(children) {
      let start = this.values[children.c_key].start;
      let end = this.values[children.c_key].end;
      this.$emit("update:data", { key: children.c_key, value: start+"|||"+end });
    },
    resetField() {
      if(this.guide.hidden || this.guide.disabled) {
        for(let key in this.values) {
          this.values[key] = null;
        }
      }
    }
    
  }
}
</script>

<style scoped>

</style>